<template>
    <div class="home-page">
        <app-feature-page></app-feature-page>
            <template v-for="(category, index) in categories">
                <b-container v-if="STYLES[index].type === 'light'" :key="category.id" style="padding: 0" class="mb-4">
                    <b-container>
                        <h2 style="text-transform: capitalize;">{{category.name}}</h2>
                        <div class="bar" :style="{background: STYLES[index].color}"></div>
                        <app-main-posts-by-cat :category="category.id"></app-main-posts-by-cat>
                    </b-container>
                </b-container>
                <div v-if="STYLES[index].type === 'full'" 
                    :key="category.id" class="big-bar mb-4 mt-4" :style="{background: STYLES[index].color}">
                   <b-container>
                        <b-container style="padding: 0;">
                            <h2 style="text-transform: capitalize;">{{category.name}}</h2>
                            <app-main-posts-by-cat :category="category.id"></app-main-posts-by-cat>
                        </b-container>
                   </b-container>
                </div>
            </template>
    </div>
</template>

<script>
import FeaturePage from './FeaturePage.vue'
import MainPostsByCat from './MainPostsByCat.vue'
import  { store, STYLES }  from '../../firebase/categories'
export default {
    name: 'home-page',
    data() {
        return {
            store,
            STYLES,
        }
    },
    components: {
        appFeaturePage: FeaturePage,
        appMainPostsByCat : MainPostsByCat
    },
    computed: {
        categories () { 
            return this.store.categories 
        },
    },
}
</script>

<style scoped lang="scss">
 @import '../../styles/components/home/HomePage.scss'
</style>